import { Injectable } from '@angular/core';
import { VkmVehicle } from '../classes/vkm-vehicle';
import { Utils } from '../utils.class';
import { RealtimeType } from './realtime/realtime-type.enum';
import { RealtimeService } from './realtime/realtime.service';
import { WebsocketService } from './websocket/websocket.service';

@Injectable({ providedIn: 'root' })
export class VkmVehicleService extends RealtimeService<VkmVehicle> {
    constructor(protected websocketService: WebsocketService) {
        super(websocketService, RealtimeType.vkmVehicle);
    }

    itemInDaterange(vehicle: VkmVehicle, fromDate: Date, toDate: Date) {
        return (
            !vehicle.date ||
            (Utils.getTimeOrNull(vehicle.date) <= Utils.getTimeOrNull(toDate) &&
                Utils.getTimeOrNull(vehicle.date) >= Utils.getTimeOrNull(fromDate))
        );
    }
}
